export const AppRoutes = {
  Auth: {
    login: "login",
  },
  grid: {
    index: "igrid",
  },
  Error: {
    base: "pages",
    comingSoon: "pages/coming-soon",
    notFound: "pages/404",
    notAuth: "pages/401",
  },
  Activities: {
    taskboard: "taskboard",
  },
  Notification: {
    base: "notifications",
    dispatch: "dispatch",
  },
  Panel: {
    base: "panel",
    profileDetails: "profile-details",
    medicalEmergency: "medical-emergency",
    loans: "loans",
    deduction: "deduction",
    overtime: "overtime",
    vacation: "vacation-request",
    vacationApproval: "vacation-approval",
    requestServices: "request-services",
    excueRequest: "excuse-request",
    documents: "documents",
  },
  MasterTable: {
    insuranceClasses: "insurance-classes",
    lineOfBusiness: "line-of-business",
    insuranceCompanies: "insurance-companies",
    insuranceBrokers: "insurance-brokers",
    policyTypes: "policy-types",
    nationalities: "nationalities",
    businessActivity: "business-activity",
    legalStatus: "legal-status",
    locations: "locations",
    businessDevelopment: {
      Sales: {
        QuotingRequirements: "quoting-requirements",
        PolicyIssuanceRequirements: "policy-issuance-requirements",
        ProspectLossReasons: "prospect-loss-reasons",
      },
      CancellationRejectionReasons: {
        CompanyRejectionReasons: "company-rejection-reasons",
        ClientRejectionReasons: "client-rejection-reasons",
        CancellationReasons: "cancellation-reasons",
      },
      insuranseSlipsBuilder: "insurance-slips-builder",
    },
    clientCategories: "client-categories",
    customerService: {
      insuranceCompaniesDocuments: "insurance-companies-documents",
      customerServiceRequirements: "customer-service-requirements",
      complaintsTypes: "complaints-types",
      complaintsSettings: "complaints-settings",
      complaintsSuspectiveCauses: "complaints-suspective-causes",
      customerServiceCancellationReason: "Cs-cancellation-reasons",
      customerServicePendingReason: "Cs-pending-reasons",
    },
    claims: {
      carsMaker: "cars-maker",
      hospitals: "hospitals",
      insuranceWorkShopDetails: "insurance-work-shop-details",
      tpaList: "tpa-list",
      claimsGeneralItems: "claims-general-items",
      claimsStatus: "claims-status",
      claimsRejectionReasons: "claims-rejection-reasons",
    },
    production: {
      libraryOfCovers: "library-of-covers",
      libraryOfInterestsInsured: "library-of-interests-insured",
      libraryOfTerms: "library-of-terms",
      libraryOfDeductibles: "library-of-deductibles",
      libraryOfExclusions: "library-of-exclusions",
      libraryOfWarranties: "library-of-warranties",
      lifePlan: "life-plan",
      vehiclesMake: "Vehicles-make",
      vehiclesType: "Vehicles-type",
      vehiclesColor: "Vehicles-color",
    },
    listOfDocuments: {
      clients: "list-of-required-documents-clients",
      claims: "list-of-required-documents-claims",
      production: "list-of-required-documents-production",
    },
    vehiclesTypes: "vehicles-types",
    contactsListPosition: "contacts-list-position",
    cities: "cities",
    defaultEmails: "default-emails",
    bankSettings: "bank-settings",
    clientSegment: "client-segment",
    segment: "segment",
  },
  Client: {
    base: "clients",
    clientRegistry: "clients",
    clientForms: "clients/create",
    clientEdit: "clients/update/",
    groups: "clients/groups",
    reports: "clients/reports",
  },
  Slips: {
    base: "slips",
    management: "slips",
    form: "slips/form",
    reports: "slips/reports",
  },
  BusinessDevelopment: {
    base: "saleslead",
    management: "saleslead",
    dashboard: "saleslead/dashboard",
    create: "saleslead/create",
    edit: "saleslead/update/",
    techEdit: "slips/update/",
    reports: {
      business: "saleslead/business-report",
      renewal: "saleslead/renewal-report",
    },
  },
  Production: {
    base: "production",
    activeList: "Policies-Members/Vehicles-Management",
    details: "policy",
    create: "production/create",
    edit: "production/update/",
    editCommissions: "Policies-Commissions-Management",
    makeInvoice: "production/invoice/",
    productionFromLead: "production/lead/",
    memberList: "production/member-list",
    reports: {
      production: "production/production-report",
      renewal: "production/renewal-report",
      renewalsNotice: "production/renewal-notice-report",
      archive: { dcNote: "production/archives/debit-credit-notes" },
    },
  },
  CustomerService: {
    base: "customer-service",
    create: "customer-service/create",
    edit: "customer-service/update/",
    reports: "customer-service/reports",
    onlineComplaints: "customer-service/onlineComplaints",
    online: "customer-service/online-requests-management",
    complaints: "customer-service/complaints",
    newComplaint: "customer-service/new-complaint",
    editComplain: "customer-service/edit/",
  },
  Claims: {
    base: "claims",
    create: "claims/create",
    edit: "claims/update/",
    reports: "claims/reports",
    onlineClaims: "claims/online-claims",
    editOnlineClaims: "claims/create-claim/",
  },
  finance: {
    base: "",
    chartOfAccounts: "chart-accounts",
    journalVoucher: "journal-voucher",
    receiptVoucher: "receipt-vouchers",
    receiptProduction: "receipt-production",
    payVouchers: "pay-vouchers",
    payVRProduction: "pay-vouchers-production",
    productionEntries: "production-entries",
    chequesManagement: "cheques-management",
    clientsChasing: "clients-chasing",
    reports: {
      base: "rpts",
      previewVoucher: "rpts/preview-voucher",
      listOfVouchers: "rpts/list-of-vouchers",
      stateOfAccount: "rpts/statement-account",
      trialBalance: "rpts/trial-balance",
      outstanding: {
        clientPremium: "clients-premium",
      },
      aging: {
        clientReceivables: "clients-receivables",
      },
    },
  },
  SystemAdmin: {
    base: "system-admin",
    create: "system-admin/create",
    privileges: "system-admin/privileges",
    clientPortal: "system-admin/clients-portal",
  },
  ITDepartment: {
    base: "IT-Department",
    requests: "IT-Department/requests",
  },
  Email: {
    base: "emails",
  },
};
